import Api from "./base/api-base";

export default class SystemNotificationsApi {
  // システムお知らせ情報一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.system_notifications
    });
  }

  // システムお知らせ情報削除
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.system_notifications,
      id: id
    });
  }

  // システムお知らせ情報取得
  info(id) {
    return Api.get({
      endpoint: Api.endpoint.system_notifications,
      id: id,
    });
  }

  // システムお知らせ情報更新
  update(id, params) {
    return Api.post({
      endpoint: Api.endpoint.system_notifications,
      id: id,
      params: params
    });
  }

  // システムお知らせ情報登録
  store(params) {
    return Api.post({
      endpoint: Api.endpoint.system_notifications,
      params: params
    });
  }
}
